import { render } from "./SingleMessageCard.vue?vue&type=template&id=da65d076&scoped=true&ts=true"
import script from "./SingleMessageCard.vue?vue&type=script&lang=ts"
export * from "./SingleMessageCard.vue?vue&type=script&lang=ts"

import "./SingleMessageCard.vue?vue&type=style&index=0&id=da65d076&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da65d076"]])

export default __exports__